import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "walkthrough-carousel-container"
};
const _hoisted_2 = {
    key: 0,
    class: "story-tap-zones"
};
const _hoisted_3 = {
    key: 1,
    class: "progress-bar-container"
};
const _hoisted_4 = { class: "progress-bar" };
const _hoisted_5 = {
    key: 2,
    class: "pagination-container"
};
const _hoisted_6 = {
    key: 0,
    class: "slide-title"
};
const _hoisted_7 = {
    key: 1,
    class: "slide-description"
};
const _hoisted_8 = {
    key: 2,
    class: "slide-sub-description"
};
const _hoisted_9 = { class: "small-text-stack" };
const _hoisted_10 = ["href"];
const _hoisted_11 = {
    key: 0,
    class: "pagination-container"
};
import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
import MGSheetSlide from './MGSheetSlide.vue';
import PaginationDots from './PaginationDots.vue';
import SwipeCarousel from './SwipeCarousel.vue';
import MGButton from './MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MGWalkthrough',
    props: {
        walkthroughData: {},
        variant: {},
        slideKey: {},
        height: {},
        compact: { type: Boolean },
        imageHeight: {},
        dotsAbove: { type: Boolean }
    },
    emits: ["slide-title-changed", "close-drawer", "slide-index-changed", "action-clicked"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const currentSlideIndex = ref(0);
        let autoScrollTimer = null;
        const preloadedMedia = ref([]);
        const swipeStartX = ref(0);
        const currentSlide = computed(() => {
            if (!props.walkthroughData || !props.walkthroughData.slides || props.walkthroughData.slides.length === 0) {
                return null;
            }
            return props.walkthroughData.slides[currentSlideIndex.value] || null;
        });
        const currentActionText = computed(() => currentSlide.value?.actionText || '');
        const currentActionUri = computed(() => currentSlide.value?.actionUri || '');
        const currentActionButtonColour = computed(() => currentSlide.value?.actionButtonColour || null);
        function handleActionClick() {
            emit('action-clicked', currentActionUri.value || null);
            if (currentActionUri.value) {
                return;
            }
            if (currentActionText.value) {
                goToNextSlide();
            }
        }
        function startAutoScroll() {
            stopAutoScroll();
            if (props.walkthroughData.autoScrollSeconds > 0) {
                autoScrollTimer = setInterval(() => {
                    goToNextSlide();
                }, props.walkthroughData.autoScrollSeconds * 1000);
            }
        }
        function stopAutoScroll() {
            if (autoScrollTimer) {
                clearInterval(autoScrollTimer);
                autoScrollTimer = null;
            }
        }
        function goToNextSlide() {
            if (props.walkthroughData && props.walkthroughData.slides) {
                const nextIndex = currentSlideIndex.value + 1;
                if (nextIndex < props.walkthroughData.slides.length) {
                    currentSlideIndex.value = nextIndex;
                }
                else if (props.variant === 'story') {
                    currentSlideIndex.value = 0;
                }
            }
        }
        function goToPreviousSlide() {
            if (currentSlideIndex.value > 0) {
                currentSlideIndex.value = currentSlideIndex.value - 1;
            }
        }
        function handleSlideChange() {
            if (props.walkthroughData.autoScrollSeconds > 0) {
                startAutoScroll();
            }
        }
        function handleTapLeft() {
            goToPreviousSlide();
            if (props.walkthroughData.autoScrollSeconds > 0) {
                startAutoScroll();
            }
        }
        function handleTapRight() {
            goToNextSlide();
            if (props.walkthroughData.autoScrollSeconds > 0) {
                startAutoScroll();
            }
        }
        function onSwipeStart(e) {
            swipeStartX.value = e.touches[0].clientX;
        }
        function onSwipeEnd(e) {
            const diff = swipeStartX.value - e.changedTouches[0].clientX;
            if (Math.abs(diff) > 50) {
                if (diff > 0) {
                    goToNextSlide();
                }
                else {
                    goToPreviousSlide();
                }
            }
        }
        function preloadAllMedia() {
            if (!props.walkthroughData || !props.walkthroughData.slides)
                return;
            const videoExtensions = ['.mp4', '.webm', '.mov', '.avi'];
            props.walkthroughData.slides.forEach((slide) => {
                if (!slide.imageUri)
                    return;
                const isVideo = videoExtensions.some(ext => slide.imageUri.toLowerCase().endsWith(ext));
                if (isVideo) {
                    const video = document.createElement('video');
                    video.preload = 'auto';
                    video.src = slide.imageUri;
                    preloadedMedia.value.push(video);
                }
                else {
                    const img = new Image();
                    img.src = slide.imageUri;
                    preloadedMedia.value.push(img);
                }
            });
        }
        watch(() => props.walkthroughData, () => {
            if (props.walkthroughData && props.walkthroughData.slides) {
                const title = props.walkthroughData.slides[currentSlideIndex.value]?.screenTitle || '';
                emit('slide-title-changed', title);
                if (props.walkthroughData.autoScrollSeconds > 0) {
                    startAutoScroll();
                }
                preloadAllMedia();
            }
        });
        watch(() => props.slideKey, (newSlideKey) => {
            if (newSlideKey && props.walkthroughData && props.walkthroughData.slides) {
                const matchingSlideIndex = props.walkthroughData.slides.findIndex((slide) => slide.key === newSlideKey);
                if (matchingSlideIndex !== -1) {
                    currentSlideIndex.value = matchingSlideIndex;
                }
                else {
                    currentSlideIndex.value = 0;
                }
            }
        });
        watch(currentSlideIndex, (newIndex) => {
            if (props.walkthroughData && props.walkthroughData.slides) {
                const title = props.walkthroughData.slides[newIndex]?.screenTitle || '';
                emit('slide-title-changed', title);
                emit('slide-index-changed', newIndex);
            }
        });
        onMounted(() => {
            if (props.walkthroughData && props.walkthroughData.slides) {
                // If slideKey is provided, find and set the matching slide
                if (props.slideKey) {
                    const matchingSlideIndex = props.walkthroughData.slides.findIndex((slide) => slide.key === props.slideKey);
                    if (matchingSlideIndex !== -1) {
                        currentSlideIndex.value = matchingSlideIndex;
                    }
                }
                const title = props.walkthroughData.slides[currentSlideIndex.value]?.screenTitle || '';
                emit('slide-title-changed', title);
                if (props.walkthroughData.autoScrollSeconds > 0) {
                    startAutoScroll();
                }
                preloadAllMedia();
            }
        });
        onBeforeUnmount(() => {
            stopAutoScroll();
        });
        __expose({
            goToNextSlide,
            goToPreviousSlide,
            currentSlideIndex
        });
        return (_ctx, _cache) => {
            const _component_v_carousel_item = _resolveComponent("v-carousel-item");
            return (_ctx.walkthroughData)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_ctx.variant === 'story')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("div", {
                                class: "tap-zone tap-left",
                                onClick: handleTapLeft
                            }),
                            _createElementVNode("div", {
                                class: "tap-zone tap-right",
                                onClick: handleTapRight
                            })
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.variant === 'story' && _ctx.walkthroughData.slides && _ctx.walkthroughData.slides.length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.walkthroughData.slides, (slide, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: `progress-${index}`,
                                        class: _normalizeClass(["progress-segment", {
                                                completed: index < currentSlideIndex.value || (index === currentSlideIndex.value && !_ctx.walkthroughData.autoScrollSeconds),
                                                animating: index === currentSlideIndex.value && _ctx.walkthroughData.autoScrollSeconds > 0
                                            }]),
                                        style: _normalizeStyle(index === currentSlideIndex.value && _ctx.walkthroughData.autoScrollSeconds > 0 ? { '--animation-duration': _ctx.walkthroughData.autoScrollSeconds + 's' } : {})
                                    }, null, 6));
                                }), 128))
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createVNode(SwipeCarousel, {
                        modelValue: currentSlideIndex.value,
                        "onUpdate:modelValue": [
                            _cache[0] || (_cache[0] = ($event) => ((currentSlideIndex).value = $event)),
                            handleSlideChange
                        ],
                        showArrows: false,
                        showButtons: false,
                        paginationDots: false,
                        itemCount: _ctx.walkthroughData.slides.length,
                        height: _ctx.height
                    }, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.walkthroughData.slides, (slide, index) => {
                                return (_openBlock(), _createBlock(_component_v_carousel_item, {
                                    key: `${slide.id}-${index}`
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(MGSheetSlide, {
                                            imageUri: slide.imageUri,
                                            videoLoop: slide.videoLoop,
                                            variant: _ctx.variant,
                                            imageHeight: _ctx.imageHeight,
                                            actionUri: slide.actionUri
                                        }, null, 8, ["imageUri", "videoLoop", "variant", "imageHeight", "actionUri"])
                                    ]),
                                    _: 2
                                }, 1024));
                            }), 128))
                        ]),
                        _: 1
                    }, 8, ["modelValue", "itemCount", "height"]),
                    (_ctx.dotsAbove)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            (_ctx.variant === 'sheet' && _ctx.walkthroughData.slides && _ctx.walkthroughData.slides.length > 1)
                                ? (_openBlock(), _createBlock(PaginationDots, {
                                    key: 0,
                                    "total-items": _ctx.walkthroughData.slides.length,
                                    "current-index": currentSlideIndex.value,
                                    maxDots: 5
                                }, null, 8, ["total-items", "current-index"]))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", {
                        class: "slide-text-stack",
                        onTouchstart: onSwipeStart,
                        onTouchend: onSwipeEnd
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.walkthroughData.slides, (slide, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: `text-${index}`,
                                class: _normalizeClass(["slide-text-content", { 'slide-text-visible': index === currentSlideIndex.value }])
                            }, [
                                (slide.title)
                                    ? (_openBlock(), _createElementBlock("h2", _hoisted_6, _toDisplayString(slide.title), 1))
                                    : _createCommentVNode("", true),
                                (slide.description)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(slide.description), 1))
                                    : _createCommentVNode("", true),
                                (!_ctx.compact && slide.subDescription)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(slide.subDescription), 1))
                                    : _createCommentVNode("", true)
                            ], 2));
                        }), 128))
                    ], 32),
                    _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_9, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.walkthroughData.slides, (slide, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: `small-${index}`,
                                    class: _normalizeClass(["smallTextLink", { 'slide-text-visible': index === currentSlideIndex.value }])
                                }, [
                                    (slide.smallText || slide.smallLink)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            href: slide.smallLink,
                                            class: "slide-small-link",
                                            target: "_blank"
                                        }, " * " + _toDisplayString(slide.smallText || slide.smallLink), 9, _hoisted_10))
                                        : _createCommentVNode("", true)
                                ], 2));
                            }), 128))
                        ])
                    ]),
                    _createElementVNode("div", null, [
                        (!_ctx.dotsAbove)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                (_ctx.variant === 'sheet' && _ctx.walkthroughData.slides && _ctx.walkthroughData.slides.length > 1)
                                    ? (_openBlock(), _createBlock(PaginationDots, {
                                        key: 0,
                                        "total-items": _ctx.walkthroughData.slides.length,
                                        "current-index": currentSlideIndex.value,
                                        maxDots: 5
                                    }, null, 8, ["total-items", "current-index"]))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", {
                            class: _normalizeClass(["action-button", { 'anchor-bottom-no-nav': _ctx.variant === 'story' }])
                        }, [
                            (currentActionText.value)
                                ? (_openBlock(), _createBlock(MGButton, {
                                    key: 0,
                                    text: currentActionText.value,
                                    arrow: true,
                                    fullWidth: true,
                                    noCaps: true,
                                    backgroundColor: currentActionButtonColour.value,
                                    onClick: handleActionClick
                                }, null, 8, ["text", "backgroundColor"]))
                                : _createCommentVNode("", true)
                        ], 2)
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
